/**
 * Admin login page.
 *
 * Phase: 4
 */

import {
  Alert,
  Anchor,
  Button,
  Card,
  Container,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { login } from "../../api/admin";
import { setToken } from "../../lib/auth";

interface LocationState {
  from?: { pathname?: string };
}

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState | null)?.from?.pathname ?? "/admin/events";

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const form = useForm({
    initialValues: { username: "", password: "" },
    validate: {
      username: (v) => (v.length < 1 ? "Kullanıcı adı gereklidir." : null),
      password: (v) => (v.length < 1 ? "Parola gereklidir." : null),
    },
  });

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      setToken(data.access_token);
      setErrorMessage(null);
      navigate(from, { replace: true });
    },
    onError: () => {
      // Generic message — don't differentiate unknown user vs wrong password.
      setErrorMessage("Geçersiz kullanıcı adı veya parola.");
    },
  });

  return (
    <Container size="xs" py="xl">
      <Stack gap="md">
        <Stack gap={4}>
          <Title order={1}>Yönetici Girişi</Title>
          <Text c="dimmed">maskder-sertifika yönetim paneli.</Text>
        </Stack>

        <Card withBorder shadow="xs">
          <form onSubmit={form.onSubmit((values) => mutation.mutate(values))}>
            <Stack gap="md">
              <TextInput
                label="Kullanıcı Adı"
                placeholder="admin"
                autoFocus
                required
                {...form.getInputProps("username")}
              />
              <PasswordInput
                label="Parola"
                required
                {...form.getInputProps("password")}
              />

              {errorMessage && (
                <Alert color="red" variant="light">
                  {errorMessage}
                </Alert>
              )}

              <Button type="submit" loading={mutation.isPending}>
                Giriş Yap
              </Button>
            </Stack>
          </form>
        </Card>

        <Text c="dimmed" size="sm" ta="center">
          <Anchor href="/">← Genel sertifika sayfasına dön</Anchor>
        </Text>
      </Stack>
    </Container>
  );
}
